import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { HelixMark } from "@/components/Logo";

function Loader() {
  return (
    <div className="flex min-h-[60vh] items-center justify-center" data-testid="auth-loading">
      <span className="animate-pulse text-cyan">
        <HelixMark className="h-10 w-10" />
      </span>
    </div>
  );
}

export function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) return <Loader />;
  if (user === false)
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  return children;
}

export function AdminRoute({ children }) {
  const { user } = useAuth();
  if (user === null) return <Loader />;
  if (user === false) return <Navigate to="/login" replace />;
  if (user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}
